import { render, staticRenderFns } from "./SubmitView.html?vue&type=template&id=209f8321&"
import script from "./SubmitView.vue?vue&type=script&lang=ts&"
export * from "./SubmitView.vue?vue&type=script&lang=ts&"
import style0 from "./SubmitView.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports